export const IMPORT_PROCESS_STATE_GLOBAL_STATE_KEY = "import-process-state"
export const UPDATE_IMPORT_PROCESS_STATE_ACTION = "update-import-process-state-action"